import React from 'react';
import { Body, Link, Box, UnorderedList, ListItem } from '@hover/blueprint';
import { ICookiePolicyCategory } from '../interfaces/ICookiePolicyCategory';

export const COOKIE_POLICY_CATEGORIES: ICookiePolicyCategory[] = [
  {
    id: 0,
    title: 'Functional',
    body: (
      <Box flexDir="column">
        <Body mb={500}>
          Functional cookies are necessary to enable portions of the Service and
          its features to work as intended. For example, we use cookies to help
          recognize and remember you when you are logged into the Service so we
          can maintain your settings and preferences, such as your logged-in
          state. These cookies do not track your browsing activity on non-HOVER
          websites.You may disable any of these functional cookies as described
          below; but if you do, various functions of the Service may be
          unavailable to you or may not work as intended.
        </Body>
        <Body mb={500}>
          Functional cookies are necessary to enable portions of the Service and
          its features to work as intended. For example, we use cookies to help
          recognize and remember you when you are logged into the Service so we
          can maintain your settings and preferences, such as your logged-in
          state. These cookies do not track your browsing activity on non-HOVER
          websites.You may disable any of these functional cookies as described
          below; but if you do, various functions of the Service may be
          unavailable to you or may not work as intended.
        </Body>
      </Box>
    ),
  },
  {
    id: 1,
    title: 'Analytical',
    body: (
      <Box flexDir="column">
        <Body mb={500}>
          We use cookies and similar tracking technologies to help us understand
          how you use our website, our mobile applications, our desktop clients,
          our white label products, such as GAF e360 and Beacon 3D+. By
          providing us with information about how you interact with our Service,
          these tools help us learn how to make the HOVER experience even better
          and customize our communications with you. On our website, for
          example, these technologies can tell us things like how you arrived at
          the site, if you have visited the site before, how long you stay on
          the site, and which pages you visit. To learn more about how to manage
          your web tracking overall, visit{' '}
          <Link
            isExternal
            href="https://allaboutdnt.com/#adjust-settings"
            fontWeight={400}
          >
            https://allaboutdnt.com/#adjust-settings.
          </Link>{' '}
          We use the following analytics technologies:
        </Body>
        <UnorderedList mb={500} ml={0}>
          <ListItem mb={500}>
            Google Analytics. To learn more about Google Analytics and your
            privacy, visit the “How Google uses data when you use our partners’
            sites or apps” page at{' '}
            <Link
              isExternal
              href="https://www.google.com/policies/privacy/partners/"
              fontWeight={400}
            >
              www.google.com/policies/privacy/partners/
            </Link>
            . To opt out of being tracked by Google Analytics when using our
            website, visit{' '}
            <Link
              isExternal
              href="https://tools.google.com/dlpage/gaoptout"
              fontWeight={400}
            >
              https://tools.google.com/dlpage/gaoptout
            </Link>
            .
          </ListItem>
          <ListItem mb={500}>
            Branch.io. To learn more about Branch.io and your privacy, visit{' '}
            <Link
              isExternal
              href="https://branch.io/policies/#privacy"
              fontWeight={400}
            >
              https://branch.io/policies/#privacy
            </Link>
            . To opt out of being tracked by Branch.io on your mobile device(s),
            visit{' '}
            <Link
              isExternal
              href="https://branch.io/policies/#opt-out"
              fontWeight={400}
            >
              https://branch.io/policies/#opt-out
            </Link>
            .
          </ListItem>
          <ListItem mb={500}>
            Google Tag Manager – Tracks user behavior on the Websites, which
            helps us better understand how users are using the Websites. Learn
            more at{' '}
            <Link
              isExternal
              href="https://support.google.com/tagmanager/answer/6102821"
              fontWeight={400}
            >
              https://support.google.com/tagmanager/answer/6102821
            </Link>
            , and to opt out, visit{' '}
            <Link
              isExternal
              href="https://support.google.com/analytics/answer/7519794"
              fontWeight={400}
            >
              https://support.google.com/analytics/answer/7519794
            </Link>
            .
          </ListItem>
          <ListItem mb={500}>
            Mix Panel – Mix Panel tracks user behavior on our HOVER products,
            which helps us to improve the HOVER service. Learn more at{' '}
            <Link
              isExternal
              href="https://mixpanel.com/legal/privacy-policy/"
              fontWeight={400}
            >
              https://mixpanel.com/legal/privacy-policy/
            </Link>
            . To opt-out, visit{' '}
            <Link
              isExternal
              href="https://mixpanel.com/optout"
              fontWeight={400}
            >
              https://mixpanel.com/optout
            </Link>
            .
          </ListItem>
          <ListItem mb={500}>
            Segment – To learn more about Segment and your privacy, visit{' '}
            <Link
              isExternal
              href="https://segment.com/legal/privacy/"
              fontWeight={400}
            >
              https://segment.com/legal/privacy/
            </Link>
          </ListItem>
          <ListItem mb={100}>
            Braze – Braze is a platform for life-cycle marketing campaigns
            through first party channels, such as email, SMS, mobile and web
            push notifications, and in-app/in-browser messaging. To learn more
            about Braze and your privacy, visit{' '}
            <Link
              isExternal
              href="https://www.braze.com/privacy"
              fontWeight={400}
            >
              https://www.braze.com/privacy
            </Link>
          </ListItem>
        </UnorderedList>
      </Box>
    ),
  },
  {
    id: 2,
    title: 'Advertising',
    body: (
      <Box flexDir="column">
        <Body mb={500}>
          We collect a unique ad tracking identifier (the Advertising Identifier
          or “IDFA” on Apple devices and the Google Advertising ID or “GAID” on
          Android devices) from your device. These identifiers are unique to
          your device, but you can reset them or limit their use through your
          device settings, as described below. These identifiers do not contain
          your name or email address. We use these ad tracking identifiers
          together with our analytics technologies in order to inform our
          targeted advertising initiatives.
        </Body>
        <Body mb={500}>
          These third-party cookies are placed by third-party advertising
          platforms or networks to collect information about your visits to and
          actions on certain pages of our Websites so that they can deliver ads
          for relevant HOVER products and services to you later, such as when
          you are on certain third-party sites. These cookies also track ad
          performance.
        </Body>
        <Body mb={500}>
          We do not sell, rent, or share personal data with third parties as
          defined under the California Consumer Privacy Act of 2018 (California
          Civil Code Sec. 1798.100 et seq.), and we do not sell, rent, or share
          personal data with third parties for their direct marketing purposes
          as defined under California Civil Code Sec. 1798.83. We do permit
          third parties to collect personal data as described in our Privacy
          Policy for the business purposes described here.
        </Body>
        <Body mb={500}>
          If you wish to opt-out of cookies that collect information to serve
          you interest-based ads generally, you may opt-out by clicking{' '}
          <Link isExternal href="https://thenai.org/opt-out/" fontWeight={400}>
            here
          </Link>
        </Body>
      </Box>
    ),
  },
  {
    id: 3,
    title: 'Social Media',
    body: (
      <Box flexDir="column">
        <Body mb={500}>
          Our website uses social media features provided by companies and
          services such as Facebook, Twitter, LinkedIn and others to enable you
          to share information with these channels. The social features are
          identified on our website by our display of the companies’ logos.
          These cookies are owned and controlled by third parties, and therefore
          the third parties – and not HOVER – are responsible for their use. As
          such, we can’t guarantee that we have listed every cookie you might
          get from a third party since a third party could change these cookies
          at any time as their needs change.
        </Body>
        <UnorderedList ml={0} mb={500}>
          <ListItem mb={500}>
            Facebook:{' '}
            <Link
              isExternal
              href="https://www.facebook.com/about/privacy"
              fontWeight={400}
            >
              https://www.facebook.com/about/privacy
            </Link>
          </ListItem>
          <ListItem mb={500}>
            Twitter:{' '}
            <Link isExternal href="http://twitter.com/privacy" fontWeight={400}>
              http://twitter.com/privacy
            </Link>
          </ListItem>
          <ListItem mb={500}>
            LinkedIn:{' '}
            <Link
              isExternal
              href=" http://www.linkedin.com/static?key=privacy_policy"
              fontWeight={400}
            >
              http://www.linkedin.com/static?key=privacy_policy
            </Link>
          </ListItem>
        </UnorderedList>
      </Box>
    ),
  },
];
